<!--
  @Description Bug提交新增弹窗
  @Date 2022-03-18
  @Author liushuo

  @Description 数据处理编辑/新增
  @Date 2022-10-25
  @Author liufu
-->
<template>
  <vxe-modal v-model="isShow" size="mini" width="80%" height="90%" @show="showWindows" @hide="hideWindows" show-zoom>
    <!-- 标题 -->
    <template #title>
      <!-- 问题编号 -->
      <span>{{ '提交Bug' }}</span>
      <!-- 模块名称 -->
      <!-- <span style="margin-left: 10px">{{ `[${form.groupName}]` }}</span> -->
      <!-- 页面名称 -->
      <span style="margin-left: 5px">{{ form.vuePath }}</span>
    </template>

    <div class="modal-dv">
      <!-- 编辑区域 -->
      <div class="edit-dv">
        <el-form :model="form" ref="FormRef" :validate-on-rule-change="false" :rules="rules" size="small">
          <!-- 第一行 -->
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="标题" prop="title">
                <el-input
                  v-model="form.title"
                  autocomplete="off"
                  :placeholder="placeholderConfig.input"
                  :disabled="!this.$parent.Authority.edit"
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品类型" prop="productionType">
                <el-select
                  clearable
                  filterable
                  v-model="form.productionType"
                  size="small"
                  :disabled="!this.$parent.Authority.edit"
                  :placeholder="placeholderConfig.select"
                >
                  <el-option
                    v-for="i of selectOptions.productionType"
                    :key="i.name + ''"
                    :label="i.name"
                    :value="i.value"
                  ></el-option>
                </el-select>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="模块" prop="groupName">
                <el-input
                  v-model="form.groupName"
                  autocomplete="off"
                  :placeholder="placeholderConfig.input"
                  :disabled="!this.$parent.Authority.edit"
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="菜单" prop="vuePath">
                <el-input
                  v-model="form.vuePath"
                  autocomplete="off"
                  :placeholder="placeholderConfig.input"
                  :disabled="!this.$parent.Authority.edit"
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第二行 -->
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="提出人" prop="openedBy">
                <el-select
                  clearable
                  filterable
                  v-model="form.openedBy"
                  size="small"
                  :disabled="true"
                  :placeholder="placeholderConfig.select"
                >
                  <el-option
                    v-for="i of selectOptions.persons"
                    :key="i.name + ''"
                    :label="i.name"
                    :value="i.value"
                  ></el-option>
                </el-select>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6"
              ><el-form-item label="当前指派" prop="assignedTo">
                <el-select
                  clearable
                  filterable
                  v-model="form.assignedTo"
                  size="small"
                  :disabled="!this.$parent.Authority.edit"
                  :placeholder="placeholderConfig.select"
                >
                  <el-option
                    v-for="i of selectOptions.persons"
                    :key="i.name + ''"
                    :label="i.name"
                    :value="i.value"
                  ></el-option>
                </el-select>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="要求完成日期" prop="deadLineTime">
                <el-date-picker
                  v-model="form.deadLineTime"
                  v-date
                  type="date"
                  :placeholder="placeholderConfig.input"
                  value-format="yyyy-MM-dd"
                  :disabled="!this.$parent.Authority.edit"
                ></el-date-picker>
                <template slot="error" slot-scope="slot">
                  <div class="error-icon">
                    <el-tooltip :content="slot.error" placement="bottom" effect="light">
                      <i class="el-icon-warning"></i>
                    </el-tooltip>
                  </div>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- // TODO 新增的时候不可改 -->
              <el-form-item label="问题状态" prop="status">
                <el-select
                  clearable
                  filterable
                  v-model="form.status"
                  size="small"
                  disabled
                  :placeholder="placeholderConfig.select"
                >
                  <!-- :disabled="!this.$parent.Authority.edit || this.operateType === 'add'" -->
                  <el-option
                    v-for="i of selectOptions.status"
                    :key="i.name + ''"
                    :label="i.name"
                    :value="i.value"
                  ></el-option>
                </el-select>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <!-- 附件框 -->
              <AttachmentCache
                ref="AttachmentCache"
                :cacheFileID="cacheFileID"
                @uploadFileSuccess="uploadFileSuccess"
              />
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <span style="font-size: 14px">重现步骤</span>
              <!-- 富文本框 -->
              <YKEditor ref="YKEditor" v-model="form.requirementDesc" :editorHeight="editorHeight" />
              <!-- </el-form-item> -->
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="button-dv">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button v-if="form.id <= 0" type="primary" @click="uploadAttachment">上传附件</el-button>
        <el-button @click="cancel">返回</el-button>
      </div>
    </div>
  </vxe-modal>
</template>

<script>
import YKEditor from '@/components/Editor/YKEditor.vue'
import AttachmentCache from './component/AttachmentCache.vue'

export default {
  name: 'BugEditModal',
  components: {
    YKEditor,
    AttachmentCache
  },
  props: {
    parentObj: Object
  },
  data() {
    return {
      // 富文本编辑器内容
      editorContent: '',
      // editorHeight: '300px',
      // 操作类型 ['add' | 'update']
      operateType: 'add',
      // 弹窗是否打开
      isShow: false,
      form: {
        id: 0,
        ykDataProcessingID: 0,
        productionType: '',
        groupName: '',
        vuePath: '',
        title: '',
        requirementDesc: '',
        openedBy: '',
        assignedTo: '',
        status: '',
        closedTime: '',
        createTime: ''
      },
      rules: {},
      // 特殊权限
      spcial: false,
      frontEngineerCache: '',
      backEngineerCache: '',
      techTesterCache: '',
      businessTesterCache: '',
      // 下拉框列表
      combobox: {
        // 说明类型
        result: []
      },
      // 历史说明列表
      historyInsList: [
        // {
        //   type: '提出',
        //   date: '2021-12-20 08:28',
        //   user: '张三',
        //   instruction: '前端处理人修改为李四'
        // },
      ],
      selectOptions: {
        productionType: [],
        productionVersion: [],
        // 影响版本
        yingxiangbanben: [
          {
            name: '/',
            value: '/'
          }
        ],
        // 严重程度
        status: [
          {
            name: '激活',
            value: '激活'
          },
          {
            name: '已解决',
            value: '已解决'
          }
        ],
        // 优先级
        youxianji: [
          {
            name: 'I',
            value: 'I'
          },
          {
            name: 'II',
            value: 'II'
          },
          {
            name: 'III',
            value: 'III'
          }
        ],
        BugType: [
          {
            name: '代码错误',
            value: '代码错误'
          },
          {
            name: '下发相关',
            value: '下发相关'
          },
          {
            name: '数据处理',
            value: '数据处理'
          },
          {
            name: '其他',
            value: '其他'
          }
        ],
        persons: [],
        frontEngineer: [],
        backEngineer: [],
        techTester: [],
        businessTester: []
      },
      // 新增上传文件使用的id
      cacheFileID: 0,
      // 保存类型
      saveType: ''
    }
  },
  methods: {
    // 上传成功事件
    uploadFileSuccess() {
      // console.log('成功!')
      const that = this
      if (this.saveType === 'add') {
        that.$message.success('保存成功')
        that.initFormData()
        that.closeModal()
        that.$emit('getList')
      } else {
        this.$message.success('修改成功')
        this.closeModal()
        this.$emit('sureUpdateForm', this.form)
      }
    },
    // 上传附件
    uploadAttachment() {
      this.$refs.AttachmentCache.uploadAttachment()
    },
    // 监听模态框开启
    async showWindows() {
      this.setFormRules()
      // 获取人员下拉框
      await this.getPerson()
      await this.getProduct()
    },
    initFormData() {
      this.form = {
        ykDataProcessingID: 0,
        productionType: '',
        groupName: '',
        vuePath: '',
        title: '',
        requirementDesc: '',
        openedBy: '',
        assignedTo: '',
        status: '',
        closedTime: '',
        createTime: ''
      }
    },
    // 设置表单校验规则
    setFormRules() {
      this.rules = {
        title: [{ required: true, message: '请填写标题', trigger: 'change' }],
        productionType: [{ required: true, message: '请选择产品类型', trigger: 'change' }],
        assignedTo: [{ required: true, message: '请选择当前指派', trigger: 'change' }],
        status: [{ required: true, message: '请填写问题状态', trigger: 'change' }]
      }
    },
    // 获取人员数据
    async getPerson() {
      this.selectOptions.persons = []

      const { data: res } = await this.$http.post('/Common/YKUser/list', {
        pageIndex: 1,
        pageSize: 99999
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      for (let item of res.data.rows) {
        const temp = {
          name: item.name,
          value: item.name
        }
        this.selectOptions.persons.push(temp)
      }
      this.initData()
    },
    // 初始化数据
    initData() {
      this.form.openedBy = this.curUserName
      this.form.status = '激活'
    },
    // 获取产品类型、产品版本下拉框
    async getProduct() {
      this.selectOptions.productionType = []
      const { data: selectRes } = await this.$http.get('/Common/BMenuGroup/select-item')
      if (selectRes.isSuccess) {
        for (let item of selectRes.data) {
          switch (item.code) {
            case 'ProductionType':
              this.selectOptions.productionType.push(item)
              break
          }
        }
      }
    },
    // 监听模态框关闭
    hideWindows() {
      this.$refs['FormRef'].resetFields()
      this.$refs.AttachmentCache.cacheAttachmentList = []
    },
    // 保存
    async save() {
      if (!this.$parent.Authority.edit) {
        return false
      }

      const isCanSave = await this.validForm()
      if (isCanSave) {
        if (!this.form.id) {
          // 调用保存接口
          this.add()
        } else {
          this.update()
        }
      }
    },
    // 校验表单
    async validForm() {
      let flag = false
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      if (!flag) {
        this.$message.error('请正确填写信息')
      }
      return flag
    },
    // 发起保存请求
    async add() {
      let form = this.removeObjectNull(this.form)
      const { data: res } = await this.$http.post('/Common/DPBugs/both', form)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      if (this.$refs.AttachmentCache.cacheAttachmentList.length > 0) {
        this.cacheFileID = res.data
        this.saveType = 'add'
        this.$refs.AttachmentCache.sureUpload()
      } else {
        // res.data 返回的是当前单据id
        this.$message.success('保存成功')
        this.initFormData()
        this.closeModal()
        this.$emit('getList')
      }
    },
    // 修改接口
    async update() {
      let form = this.removeObjectNull(this.form)
      const { data: res } = await this.$http.put('/Common/DPBugs/both', form)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      // res.data 返回的是当前单据id
      this.$message.success('修改成功')
      this.closeModal()
      this.$emit('sureUpdateForm', this.form)
    },
    openModal() {
      this.isShow = true
    },
    closeModal() {
      this.isShow = false
    },
    // 赋值历史说明
    setHistoryInsList(form) {
      // form.comment 说明
      const comment = form.comment
      this.historyInsList = this.formatContentWrap(comment)
    },
    /**
     * @description 格式化说明
     * @param {String} comment 说明内容
     * @returns Array[{type, date, user, instruction}]
     */
    formatContentWrap(comment) {
      let res = []
      if (comment == null || comment.trim() === '') {
        return res
      }
      // 1.按句分割
      let sentence = comment.split('!#!')
      sentence.forEach(v => {
        // 2.按字段分割，[0]:类型  [1]:日期 [2]:人名  [3]:说明  [4]:问题说明id
        const word = v.split('!&!')
        const temp = {
          type: word[0] || '无',
          date: word[1] || '无',
          user: word[2] || '无',
          instruction: word[3] || '无'
        }
        if (this.$store.state?.systemSetting?.explainSort && this.$store.state.systemSetting.explainSort === 'asc') {
          res.unshift(temp)
        } else {
          res.push(temp)
        }
      })
      return res
    },
    // 返回
    cancel() {
      this.closeModal()
      // TODO 重置表单数据
    }
  },
  computed: {
    editorHeight() {
      const modalTitleHeight = 31
      const modalPadding = 20
      const rowHeight = 78 * 2
      const dividerHeight = 20
      const buttonHeight = 60
      const editorHeaderHeight = 84
      const attachmentHeight = 53
      return (
        Number(this.$store.state.clientHeight) * 0.9 -
        modalTitleHeight -
        modalPadding -
        rowHeight -
        dividerHeight -
        buttonHeight -
        editorHeaderHeight -
        attachmentHeight + // 主要用于新增时有附件的情况下变短
        'px'
      )
    },
    // 当前登录用户名
    curUserName() {
      return this.$store.state.userInfo.userName
    }
  },
  watch: {
    form: {
      handler(newVal) {
        this.setHistoryInsList(newVal)
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
@history-dv-height: 200px;
@all-dv-width: 98%;
// 编辑说明和历史说明之间的间隔
@dv-margin: 10px;
// 间隔槽总高度 = 高度 + margin
@gap-margin: 10px;
@gap-height: 30px;
@gap-padding-bottom: 10px;
// 整体内边距
@all-dv-padding: 10px;
@button-dv-height: 60px;

.modal-dv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0 @all-dv-padding;
  position: relative;
}

.edit-dv {
  width: 100%;
  margin: 0 auto;
  // height: calc(
  //   // dv-margin: 需要乘的数值 = 整体区块数量 + 1（如加了一个 gap-dv，则需要 + 1）
  //     100% - @history-dv-height - @dv-margin*4 - @gap-height - @gap-margin
  // );
  height: calc(100% - @button-dv-height);
  overflow-y: scroll;
  overflow-x: hidden;
}

.button-dv {
  width: calc(100% - @all-dv-padding * 2);
  height: @button-dv-height;
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-dv::-webkit-scrollbar {
  display: none;
}

.btn-dv-prohibit {
  transition: none !important;
  opacity: 0.5 !important;
}
.btn-dv-prohibit:hover {
  cursor: not-allowed !important;
  opacity: 0.5 !important;
}

.el-row {
  margin-bottom: 12px !important;
}

/deep/ .el-button {
  width: 120px;
}
.attachmentContainer {
  word-break: break-word;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none !important;
  }
}
</style>
